import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		companyNotificationsRoot: {
			maxWidth: '670px',
			width: '100%',
			marginTop: '30px',
			marginBottom: '30px',
			padding: '0px 10px',
			position: 'relative',
		},
		notificationItem: {
			display:'flex',
			flexFlow:'row',
			alignItems: 'center'
		},
		notificationName: {
			fontWeight: 500,
			color: '#424242',
			fontSize: '18px'
		},
		switchBtn: {
			marginLeft: 'auto',
			cursor: 'pointer'
		}
	})
